// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import { capitalizeFLetter, confirmation_modal, clipboard, fetchApiData, loadAccount, fetchItems, loadMinSellingPrices, update_product_graph } from '../fnc.js'
import PMAHeaderInfo from './ctn/pma/PMAHeaderInfo.js'
import Loading from '../Pages/ctn/Loading';
import Pagination from './ctn/eBay/Pagination.js'
import $ from 'jquery';
const refConst = require("../constants.js").v

const initialState = {
	accountAccepted: false,
	products: {},
	pmaData: [],
	pmaStores: [],
	currentAccountLines: [],
	lineAccess: {from: null, to: null},
	dataNumber: null,
	pma: null
}

export default function PMA(props){

	const adminAccess = [
		"-MjVxK86GVBUKL5oNU66", // General admin
		"-ON1qrQ9xBbT0EbKFaTH", // PMA admin
	]

	if(!props.securityClearance(props))	return;

	console.info("sadsadsadsad", props.getUser());
	const qtyPerPage = 500;
	const [version] = useState("0.9.4");
	const [pmaData, setPmaData] = useState(initialState.pmaData);
	const [accountAccepted, setAccountAccepted] = useState(initialState.accountAccepted);
	// const [currentAccountLines, setCurrentAccountLines] = useState(initialState.currentAccountLines);
	const [lineAccess, setLineAccess] = useState(initialState.lineAccess);
	const [products, setProducts] = useState(initialState.products);
	const [pmaStores, setPmaStores] = useState(initialState.pmaStores);
	const [refreshWindow, setRefreshWindow] = useState(0);
	const [dataNumber, setDataNumber] = useState(initialState.dataNumber);
	const [page, setPage] = useState(0);
	const [pma, setPma] = useState(initialState.pma);
	const [isDataLoading, setIsDataLoading] = useState(true);
	const [saveTimeouts, setSaveTimeouts] = useState({});

	useEffect(() => {
		$('.tooltipInfo').tooltip({
			placement: "right",
			template:  '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner tooltip-info-ebay"></div></div>',
		}).tooltip('update')

		$('.tooltipInfo').on('click', function() {
			$('.tooltip').tooltip('hide');
		});
	})

	useEffect(() => {
		// Calculate dynamic height for pmaTable by subtracting navbar and infoBox heights
		const calculateTableHeight = () => {
			const windowHeight = window.innerHeight;
			const navbarHeight = document.querySelector('.navbar')?.offsetHeight || 0;
			const infoBoxHeight = document.querySelector('.infoBox')?.offsetHeight || 0;
			const tableHeight = windowHeight - navbarHeight - infoBoxHeight - 90; // 20px buffer
			
			const pmaTable = document.querySelector('.pmaTable');
			if (pmaTable) {
				pmaTable.style.height = `${tableHeight}px`;
			}
		}

		// Calculate on mount and window resize
		calculateTableHeight();
		window.addEventListener('resize', calculateTableHeight);

		// Cleanup
		return () => {
			window.removeEventListener('resize', calculateTableHeight);
		}
	})

	useEffect(() => {
		if(!props.parent.match.params.idPma)	return;
		setIsDataLoading(true);
		setPmaData([]);
		setProducts({});
		fetchPMAStores();
		getPMADataCount();
		getPma();
	}, [props.parent.match.params.idPma])

	useMemo(() => {
		if(lineAccess?.from && lineAccess?.to){
			setDataNumber(lineAccess.to - lineAccess.from);
		}
	}, [lineAccess, pmaData])

	useEffect(() => {
		if(props.accounts && props.accounts.length > 0 && props.parent.match.params.idPma){
			fetchPMAAccount();
		}
	}, [props.accounts, props.parent.match.params.idPma])

	useEffect(() => {
		if(pmaData.length > 0){
			fetchItemsFinale((listPerId) => {
				addMinSellingPrices(listPerId, (listPerId) => {
					console.info("listPerIdlistPerIdlistPerId", listPerId);
					setProducts(listPerId);
				});
			});
		}
	}, [pmaData])

	useEffect(() => {
		// if there is a limit of line available for this user, we remove the unnecessary data from the pmaData
		getPmaData();
	}, [lineAccess, page])

	// Cleanup timeouts on unmount
	useEffect(() => {
		return () => {
			Object.values(saveTimeouts).forEach(timeoutId => {
				if (timeoutId) clearTimeout(timeoutId);
			});
		};
	}, [saveTimeouts])

	let getPmaData = () => {

		let from = lineAccess?.from;
		setIsDataLoading(true);

		fetchApiData("eio", "getPMAData", {
			filters: JSON.stringify({
				id_pma: props.parent.match.params.idPma,
				from: from + parseInt(page) * parseInt(qtyPerPage),
				count: parseInt(qtyPerPage)
			})
		}, null, (r) => {
			console.info("getPMAData", r);
			console.info("getPMAData2", lineAccess);
			if(r.data && r.data.length > 0){
				r.data.forEach(d => {
					d.priceSaved = {};
					d.qtySaved = {};
				})
				setPmaData(r.data ?? []);
			}else{
				setPmaData([]);
			}
			setIsDataLoading(false);
		})
	}

	let getPma = () => {
		fetchApiData("eio", "getPMA", {
			filters: JSON.stringify({
				id: props.parent.match.params.idPma
			})
		}, null, (r) => {
			console.info("getPMA", r);
			setPma(r.data && r.data.length > 0? r.data[0] : null);
		})
	}

	let isAdmin = () => {
		let permissions = props.getUser().permissions;
		if(!permissions || !adminAccess)	return false;
		return permissions.some(p => adminAccess.indexOf(p) !== -1);
	}

	let updateFinale = (sku, otherProps, callback) => {
		if(!sku)	return;
		update_product_graph([{
			"Product ID": sku,
			...otherProps
		}], (r) => {
			console.info("updateFinale", r);
			if(r.errors){
				props.info({error: r.errors});
			}else if(r.success){
				setRefreshWindow(prev => prev + 1);
				if(callback)
					callback(r);
			}
		})
	}

	let addMinSellingPrices = (productsList, callback) => {
		let args = [];
		Object.values(productsList).forEach(p => {
			args.push({
				sku: p.sku,
				weight: p.weight,
				weight_unit: p.weight_unit,
				cost: p.cost,
				shipping_cost: p?.avg_shipping_cost
			})
		})

		loadMinSellingPrices(args, (dr) => {
			console.info("addMinSellingPrices", dr);
			let d = dr.data;
			for (const key in productsList) {
				if (Object.prototype.hasOwnProperty.call(productsList, key)) {
					productsList[key].minPriceData = d.find(d => d.sku === productsList[key].sku)
				}
			}
			if(callback)
				callback(productsList);
		})
	}

	let fetchPMAAccount = () => {
		fetchApiData("eio", "getPMAAssignedAccount", {
			filters: JSON.stringify({
				'id_pma': props.parent.match.params.idPma
			})
		}, null, (r) => {
			console.log("PMA_assigned_to_accounts", r)
			if(r.data.length > 0){
				// Merge the accounts with the accounts from the props
				let accAccepted = props.accounts.filter(account => r.data.some(assignedAccount => assignedAccount.id_account === account.id));
				setAccountAccepted(accAccepted);
				console.info("accountsAcceptedaccountsAccepted", accAccepted);
				console.info("accountsAcceptedaccountsAccepted22", props.getUser().id);
				let currUserId = props.getUser().id;
				// currUserId = 230
				let findAccAccess = r.data.filter(d => d.id_account === currUserId)
				//setCurrentAccountLines(findAccAccess.length > 0? findAccAccess[0] : []);
				setLineAccess(findAccAccess.length > 0? {
					from: findAccAccess[0].line_from,
					to: findAccAccess[0].line_to
				} : {from: null, to: null}); // We can change the value here to test the access
			}else{
				setLineAccess({from: null, to: null});
				setAccountAccepted([]);
			}refConst
		})
	}

	let fetchItemsFinale = (callback) => {
		fetchItems("eio", {
			"idProductList": pmaData.map(item => item.id_product).join(","),
			"addShipping": true
		}, (r) => {
			console.info("fetchItemsFinale", r);
			if(r.error){
				props.info({error: r.error});
				setProducts({});
			}else{
				let listPerId = {}
				r.data.some(o => {
					listPerId[String(o.id)] = o;
				})
				if(callback)
					callback(listPerId);
				else
					setProducts(listPerId);
			}
		})
	}

	let getPMADataCount = () => {
		fetchApiData("eio", "getPMADataCount", {
			id_pma: props.parent.match.params.idPma
		}, null, (r) => {
			console.info("getPMADataCount", r);
			setDataNumber(r.count);
		})
	}
	let fetchPMAStores = () => {
		fetchApiData("eio", "getPMAStores", {
			filters: JSON.stringify({
				'id_pma': props.parent.match.params.idPma
			})
		}, null, (r) => {
			console.info("fetchPMAStores", r);
			r.data.sort((a, b) => a.id - b.id);
			setPmaStores(r.data?? []);
		})
	}

	let getPmaStoreFromId = (id_pma_stores) => {
		if(id_pma_stores){
			let stF2 = pmaStores.find(s => s.id === id_pma_stores)
			return stF2
		}
		return null;
	}

	let calculateSuggestedPrice = (inputPrice, minPrice) => {
		if (!inputPrice || !minPrice) return minPrice;
		const numInputPrice = parseFloat(inputPrice);
		const numMinPrice = parseFloat(minPrice);
		
		if (numInputPrice <= numMinPrice) {
			return numMinPrice !== null ? numMinPrice : null;
		}
		
		// Calculate 2% discount if possible
		const suggestedPrice = numInputPrice * 0.98;
		return suggestedPrice >= numMinPrice ? suggestedPrice : numMinPrice;
	}

	let checkPossibleValueError = (storeInfo, pmaData, product, storeData) => {
		console.info("checkPossibleValueError", storeInfo, pmaData, product, storeData);

		if(!storeInfo.price){
			if("price_warning" in storeInfo)
				delete storeInfo.price_warning;
			return;
		}
		if(product && product.upc && product.upc == storeInfo.price){
			storeInfo.price_warning = "The price is equal to the UPC, please check your value";
		}else if(product && product.cost !== undefined && storeInfo.price){
			const productCost = parseFloat(product.cost);
			const parsedPrice = parseFloat(storeInfo.price);
			if(!Number.isNaN(productCost) && !Number.isNaN(parsedPrice) && parsedPrice > productCost + (productCost * 5)){
			// If the price is 500% higher than the cost, we give a warning
			storeInfo.price_warning = "Very high margin, please check your value";
			}
		}else if(storeInfo.price_warning){
			delete storeInfo.price_warning;
		}
		// Check if the value is equal to the upc
		setRefreshWindow(prev => prev + 1);
	}
		
	let submitMainDataStore = (data, callback) => {

		fetchApiData("eio", "setPMADataStoreInfo", {
			'data': JSON.stringify(data)
		}, null, (r) => {
			console.log("setPMADataStoreInfo", r)
			if(callback)
				callback(r);
		})
	}

	let debouncedSave = (key, saveFunction, delay = 500) => {
		// Clear existing timeout for this key
		if (saveTimeouts[key]) {
			clearTimeout(saveTimeouts[key]);
		}
		
		// Set new timeout
		const timeoutId = setTimeout(() => {
			saveFunction();
			setSaveTimeouts(prev => {
				const newTimeouts = { ...prev };
				delete newTimeouts[key];
				return newTimeouts;
			});
		}, delay);
		
		setSaveTimeouts(prev => ({
			...prev,
			[key]: timeoutId
		}));
	}
	let submitMainData = (data, callback) => {

		fetchApiData("eio", "setPMAData", {
			'data': JSON.stringify([data])
		}, null, (r) => {
			console.log("setPMAData", r)
			if(callback)
				callback(r);
		})
	}

	let resetPage = () => {
		for (const key in initialState) {
			if (initialState.hasOwnProperty(key)) {
				// const element = initialState[key];
				let val = JSON.parse(JSON.stringify(initialState[key]))
				console.info('Eval result', eval("set" + capitalizeFLetter(key))(val));
			}
		}
	}

	let isAuthorized = () => {
		if(isAdmin())	return true;	
		if(!accountAccepted || accountAccepted.length === 0)	return false;
		let found = accountAccepted.find(account => account.id === props.getUser().id);
		return found !== undefined;
	}

	console.info("accountAccepted", accountAccepted);
	console.info("props.accounts", props.accounts);
	console.info("productsproducts", products);
	console.info("pmaDatapmaData", pmaData);
	console.info("lineAccess", lineAccess);
	console.info("props.accounts", props.accounts);
	console.info("isAdmin()isAdmin()", isAdmin());

	let storeIdToTitle = (storeId) => {
		let found = pmaStores.find(s => s.id === storeId);
		return found ? found.title : storeId;
	}

	let hasLineToChange = true
	/* if(lineAccess.from !== null && lineAccess.from > pmaData.length)
		hasLineToChange = false;*/
	
	if(pmaData.length === 0)
		hasLineToChange = false; 

	let orderIdStoresHeader = []; // The order should already match but we need to be sure
	
	return (<div>
		{
			isAuthorized()? <div>
				<PMAHeaderInfo
					pmaData={pmaData}
					idPma={props.parent.match.params.idPma}
					accountAccepted={accountAccepted}
					lineAccess={lineAccess}
					dataNumber={dataNumber}
					setPage={setPage}
					pma={pma}
					isAdmin={isAdmin}
					version={version}
					// currentAccountLines={currentAccountLines}
				/>
				{
					pmaStores.length === 0? <div className="alert">
						No stores selected for this PMA, please select some stores <button className="btn btn-primary ml-2" onClick={() => window.history.back()}>Back</button>
					</div> : ""
				}
				{
					isDataLoading? <div style={{height: '100px'}}>
						<Loading loading={true} centered={true}/>
					</div>
					: hasLineToChange? <div className="table-responsive pmaTable" style={{
						position: 'relative',
						height: '60vh'
					}}>
						<div style={{
							position: 'sticky', 
							left: 0, 
							zIndex: 5,
							backgroundColor: 'var(--eio-bg-elevated)',
							// borderRight: '2px solid #dee2e6',
							width: '250px'
						}}>
							{
								pmaData.length > 0 && Object.keys(products).length > 0? <table className="table table-bordered table-striped mb-0 middeSizeText">
									<thead style={{position: 'sticky', top: 0, zIndex: 6}}>
										<tr style={{height: '65px'}}>
										<th className="text-center align-middle" style={{width: '60px', backgroundColor: 'var(--eio-bg-muted)', color: 'var(--eio-text)'}}>N</th>
										<th className="text-center align-middle" style={{backgroundColor: 'var(--eio-bg-muted)', color: 'var(--eio-text)'}}>SKU</th>
									</tr>
								</thead>
								<tbody>
									{pmaData.map((item, index) => {
										/* if(lineAccess.from !== null && lineAccess.to !== null && (index+1 < lineAccess.from || index+1 > lineAccess.to))
											return ""; */
										let currentLinePos = lineAccess?.from + parseInt(page) * parseInt(qtyPerPage) + index
												if(lineAccess?.from !== null && lineAccess?.to !== null && (currentLinePos < lineAccess?.from || currentLinePos > lineAccess?.to))
													return;

										return <tr key={index} style={{height: '110px'}}>
											<td className="text-center align-middle">{item.id}</td>
											<td className="text-center align-middle"><span className="pointer" onClick={() => {clipboard(products[item.id_product]?.sku, props)}}>{products[item.id_product]?.sku}</span></td>
										</tr>
									})}
									</tbody>
								</table> : ""
							}
						</div>
						{
							pmaData.length > 0 && Object.keys(products).length > 0? 
								<div style={{ 
									position: 'absolute', 
									top: 0, 
									left: '250px', 
									bottom: 0,
									right: 0,
									overflow: 'none',
									width: 'calc(100% - 250px)',
									height: '90%'
								}}>
									<table className="table table-bordered table-striped mb-0 middeSizeText">
										<thead style={{position: 'sticky', top: 0, zIndex: 4}}>
											<tr style={{height: '65px'}}>
																		<th className="text-center align-middle" style={{backgroundColor: 'var(--eio-bg-muted)', color: 'var(--eio-text)'}}>Supplier ID</th>
																		<th className="text-center align-middle" style={{backgroundColor: 'var(--eio-bg-muted)', color: 'var(--eio-text)'}}>UPC/EAN</th>
																		<th className="text-center align-middle" style={{backgroundColor: 'var(--eio-bg-muted)', color: 'var(--eio-text)'}}>ASIN</th>
																		<th className="text-center align-middle" style={{backgroundColor: 'var(--eio-bg-muted)', color: 'var(--eio-text)'}}>Weight (lbs)</th>
																		<th className="text-center align-middle" style={{backgroundColor: 'var(--eio-bg-muted)', color: 'var(--eio-text)'}}>Cost</th>
																		<th className="text-center align-middle" style={{backgroundColor: 'var(--eio-bg-muted)', color: 'var(--eio-text)'}}>Map</th>
																		<th className="text-center align-middle" style={{backgroundColor: 'var(--eio-bg-muted)', color: 'var(--eio-text)'}}>Options</th>
												{pmaStores.map(s => (
													orderIdStoresHeader.push(s.id),
																		<th key={s.id} className="text-center align-middle" style={{backgroundColor: 'var(--eio-bg-muted)', color: 'var(--eio-text)'}}>
														<div className="d-flex align-items-center justify-content-center">
															{s.title}
															<div 
															style={{
																width: '20px',
																height: '20px',
																borderRadius: '50%',
																backgroundColor: s.color || '#ddd',
																display: 'inline-block',
																marginLeft: '5px'
															}}
														/>
														</div>
													</th>
												))}
																		<th className="text-center align-middle" style={{backgroundColor: 'var(--eio-bg-muted)', color: 'var(--eio-text)'}}>Created</th>
											</tr>
										</thead>
										<tbody>
											{pmaData.map((d, index) => {

												/* if(lineAccess.from !== null && lineAccess.to !== null && (index+1 < lineAccess.from || index+1 > lineAccess.to))
													return ""; */

												let currentLinePos = lineAccess?.from + parseInt(page) * parseInt(qtyPerPage) + index
												if(lineAccess?.from !== null && lineAccess?.to !== null && (currentLinePos < lineAccess?.from || currentLinePos > lineAccess?.to))
													return;

												let listTdStores = []
												pmaStores.map(storeData => {

													let s = d.stores.find(s => s.id_pma_stores === storeData.id)

													if(!s){
														s = {
															id_pma_stores: storeData.id,
															price: null,
															pack_qty: null
														}
													}

													// let storeData = getPmaStoreFromId(s?.id_pma_stores)
													let borderColor = s && Object.keys(d.priceSaved).indexOf(String(s.id_pma_stores)) !== -1 ? " border-info" : "";

													listTdStores.push(<td key={s?.id_pma_stores} className="pt-0 pb-0 align-middle middeSizeText">
														{
															"price_warning" in s && s?.price_warning? <div className="alert alert-warning border mb-2 p-1">
																{s.price_warning}
															</div> : ""
														}
														<div className="d-flex align-items-center justify-content-center h-100 w-100">
															<div className="d-flex flex-row align-items-center">
																
																<div className={"input-group mr-2"} style={{width: '130px'}}>
																	<div className="input-group-prepend">
																		<span className="input-group-text middeSizeText">$</span>
																	</div>
																	<input
																		key={`price_${d.id}_${s?.id_pma_stores}`}
																		type="number"
																		className={"form-control" + borderColor}
																		step={0.01}
																		// min={ourMin}
																		defaultValue={s?.price}
																		onChange={(e) => {
																			s.price = e.target.value
																			// return s.price = e.target.value > 0? e.target.value : null
																		}}
																		onBlur={() => {
																			const storeId = String(s?.id_pma_stores);
																			const saveKey = `price_${d.id}_${storeId}`;
																			
																			d.priceSaved[storeId] = false;
																			checkPossibleValueError(s, d, products[d.id_product], storeData);
																			
																			submitMainDataStore({
																				id_pma_data: d.id,
																				id_pma_stores: s?.id_pma_stores,
																				price: s?.price,
																			}, (r) => {
																				console.info("submitMainDataStore", r);
																				if(r.success && (r.res.updated || r.res.processed || r.res.ignored)){
																					d.priceSaved[storeId] = true;
																				} else {
																					// Handle error case - show user feedback
																					console.error("Failed to save price:", r);
																					props.info({error: "Failed to save price. Please try again."});
																					d.priceSaved[storeId] = false;
																				}
																				setRefreshWindow(prev => prev + 1);
																			})
																		}} />
																</div>
																{
																	storeData && storeData.require_pack_qty? <div className="input-group flex-nowrap" style={{width: '110px'}}>
																		<div className="input-group-prepend">
																			<span className="input-group-text middeSizeText">Qty</span>
																		</div>
																		<input
																			key={`qty_${d.id}_${s?.id_pma_stores}`}
																			type="number"
																			className={"form-control" + (s?.id_pma_stores in d.qtySaved && d.qtySaved[String(s?.id_pma_stores)]? " border-success" : "")}
																			style={{width: '110px'}}
																			min="1"
																			defaultValue={s?.pack_qty}
																			onChange={(e) => s.pack_qty = e.target.value > 0? e.target.value : null}
																			onBlur={() => {
																				const storeId = String(s?.id_pma_stores);
																				const saveKey = `qty_${d.id}_${storeId}`;
																				
																				d.qtySaved[storeId] = false;
																				
																				submitMainDataStore({
																					id_pma_data: d.id,
																					id_pma_stores: s?.id_pma_stores,
																					pack_qty: s?.pack_qty
																				}, (r) => {
																					console.info("submitMainDataStore", r);
																					if(r.success && (r.res.updated || r.res.processed || r.res.ignored)){
																						d.qtySaved[storeId] = true;
																					} else {
																						// Handle error case - show user feedback
																						console.error("Failed to save quantity:", r);
																						props.info({error: "Failed to save quantity. Please try again."});
																						d.qtySaved[storeId] = false;
																					}
																					setRefreshWindow(prev => prev + 1);
																				})
																			}}
																			/>
																	</div> : ""
																}
															</div>
														</div>
													</td>)
												})
												return <tr key={index} style={{height: '110px'}}>
													<td className="text-center align-middle"><span className="pointer" onClick={() => {clipboard(products[d.id_product]?.supplier1_product_id, props)}}>{products[d.id_product]?.supplier1_product_id}</span></td>
													<td className="text-center align-middle"><span className="pointer" onClick={() => {clipboard(products[d.id_product]?.upc || products[d.id_product]?.ean, props)}}>{products[d.id_product]?.upc || products[d.id_product]?.ean}</span></td>
													<td className="text-center align-middle text-center">
														{
															d.static_asin && !d.asinEditOpen? d.static_asin : <input
																type="text"
																className={"form-control m-auto" + (d.asinSaved? " border-success" : "")}
																style={{width: '110px'}}
																onChange={(o) => d.static_asin = o.target.value}
																defaultValue={d.static_asin}
																onBlur={() => { 
																	// Reset saved state before attempting to save
																	d.asinSaved = false;
																	
																	// Update our DB Pma_data (allow empty ASINs to be saved)
																	submitMainData({
																		id: d.id,
																		static_asin: d.static_asin || null,
																	}, (r) => {
																		console.info("submitMainData_static_asin", r);
																		if(!r.errors){
																			d.asinSaved = true;
																			d.asinEditOpen = false; // Close edit mode after successful save
																		} else {
																			// Handle error case - show user feedback
																			console.error("Failed to save ASIN:", r);
																			props.info({error: "Failed to save ASIN. Please try again."});
																			d.asinSaved = false;
																		}
																		setRefreshWindow(prev => prev + 1);
																	})
																	// We also update the ASIN directly in Finale (only if ASIN exists)
																	/* if(d.static_asin) {
																		updateFinale(products[d.id_product]?.sku, {
																			ASIN: d.static_asin
																		}, (r) => {
																			if(r.errors){
																				console.error(r.errors);
																			}
																		})
																	} */
																}}
															/>
														}
														{
															d.static_asin && !d.asinEditOpen? <i className="bi bi-pencil-square pointer ml-1" onClick={() => {
																d.asinEditOpen = true;
																d.asinSaved = false; // Reset saved state when starting to edit
																setRefreshWindow(prev => prev + 1);
															}}></i> : ""
														}
													</td>
													<td className="text-center align-middle"><span className="pointer" onClick={() => {d.static_weight && !d.weightEditOpen? clipboard(d.static_weight, props) : ""	}}>
														{
															!d.static_weight || d.weightEditOpen? <input
																key={`weight_${d.id}`}
																type="number"
																className={"form-control" + (d.weight_saved? " border-info" : "")}
																step={0.01}
																defaultValue={d.static_weight}
																onChange={(e) => {
																	if(!("weight" in products[d.id_product])){
																		d.static_weight = null
																		d.static_weight_unit = "lbs"
																	}
																	d.static_weight = e.target.value
																	d.static_weight_unit = "lbs"

																	updateFinale(products[d.id_product]?.sku, {
																		"Weight per unit": d.static_weight
																	}, (r) => {
																		console.info("updateFinale", r);
																	})
																}}
																onBlur={() => {			
																	d.weight_saved = false
																	if(d.static_weight){
																		submitMainData({
																			id: d.id,
																			static_weight: d.static_weight,
																		}, (r) => {
																			console.info("submitMainData", r);
																			if(r.success && (r.res.updated || r.res.processed)){
																				if(d.static_weight.trim().length > 0)
																					d.weight_saved = true;
																			} else {
																				// Handle error case
																				console.error("Failed to save weight:", r);
																				props.info({error: "Failed to save weight. Please try again."});
																				d.weight_saved = false;
																			}
																			setRefreshWindow(prev => prev + 1);
																		})
																		updateFinale(products[d.id_product]?.sku, {
																			"Weight per unit": d.static_weight
																		}, (r) => {
																			console.info("updateFinale", r);
																		})
																	}
																}}
															/> : d.static_weight
														}
														{
															d.static_weight && !d.weightEditOpen ? <i className="bi bi-pencil-square pointer ml-1" onClick={() => {
																d.weightEditOpen = true;
																setRefreshWindow(prev => prev + 1);
															}}></i> : ""
														}
														</span>
													</td>
													<td className="text-center align-middle"><span className="pointer" onClick={() => {clipboard(d.static_cost, props)}}>{d.static_cost}</span></td>
													<td className="text-center align-middle"><span className="pointer" onClick={() => {clipboard(products[d.id_product]?.map_price, props)}}>{products[d.id_product]?.map_price}</span></td>
													<td className="text-center align-middle">
														{
															(() => {
																// Checkboxes to affect each stores like if a product was not found in any stores
																let options = []

																options.push(<div key={d.id} className="form-check form-switch">
																	<input
																		className="form-check-input pointer"
																		type="checkbox"
																		id={`flexSwitchCheckDefault${d.id}`}
																		defaultChecked={d.not_found_anywhere}
																		onChange={(e) => {
																			d.not_found_anywhere = e.target.checked

																			submitMainData({
																				id: d.id,
																				not_found_anywhere: e.target.checked
																			}, (r) => {
																				console.info("submitMainData_option", r);
																			})
																			// If it's checked, we need to set all price value to 0
																			/* d.stores.forEach(s => {
																				if(e.target.checked){
																					if(s.price === null || s.price === undefined){
																						s.price = 0
																					}
																				}else{
																					if(s.price === 0){
																						s.price = null
																					}
																				}

																				submitMainDataStore({
																					id_pma_data: d.id,
																					id_pma_stores: s?.id_pma_stores,
																					price: s?.price,
																				}, (r) => {
																					console.info("submitMainDataStore_option", r);
																					if(r.success && (r.res.updated || r.res.processed)){
																						d.priceSaved[s?.id_pma_stores] = true;
																					}
																					setRefreshWindow(refreshWindow + 1);
																				})
																			})
																			setRefreshWindow(refreshWindow + 1);	 */				
																		}}
																	/>
																	<label className="form-check-label noselect pointer" htmlFor={`flexSwitchCheckDefault${d.id}`}>Not found anywhere</label>
																	<i className="bi bi-info-circle tooltipInfo ml-1" 
																		data-toggle="tooltip" 
																		data-placement="top" 
																		title="Fill up each price field with zero"
																		data-html="true"
																	></i>
																</div>)

																return options;
															})()
														}
													</td>
													{listTdStores}
													<td className="text-center align-middle">{d.date_created}</td>
												</tr>
											})}
										</tbody>
									</table>
								</div> : <div style={{height: '100px'}}>
										<Loading loading={true} centered={true}/>
								</div>
						}
					</div> : <h4 className="alert d-flex align-items-center justify-content-center">
						No Data available
					</h4>
				}
				<Pagination 
					current_page={page}
					total_items={dataNumber?? 0}
					qtyPerPage={qtyPerPage}
					onUpdatePage={(e, newPage) => setPage(newPage-1)}
					limit_per_page={qtyPerPage}
				/>
			</div>
		: <div className="alert">
				You are not authorized to view this page
			</div>
		}
	</div>);
}
